import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import config from "./aws-exports";
import WrapperApp from "./WrapperApp";
import { configureCloudFormationAPIs } from "./config/apis";
import ErrorBoundary from "./components/ErrorBoundary";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { API_CONFIG } from './config/appConfig';

// Configure Amplify to use API_KEY for AppSync by default
// Without this, Amplify prioritizes IAM auth when user is signed in
Amplify.configure({
  ...config,
  API: {
    GraphQL: {
      endpoint: config.aws_appsync_graphqlEndpoint,
      region: config.aws_appsync_region,
      defaultAuthMode: 'apiKey',
      apiKey: config.aws_appsync_apiKey
    }
  },
  Storage: {
    AWSS3: {
      bucket: 'shcaptures100843-staging',
      region: 'eu-west-2'
    }
  }
});

// Configure CloudFormation-managed APIs (not in aws-exports.js)
configureCloudFormationAPIs();

// Create React Query client with optimized cache settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: API_CONFIG.CACHE.STALE_TIME,
      cacheTime: API_CONFIG.CACHE.CACHE_TIME,
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnMount: false, // Don't refetch on component mount if data exists
      refetchOnReconnect: false, // Don't refetch on network reconnect
      retry: 1, // Only retry once on failure
      structuralSharing: true, // Deduplicate requests
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary fallbackMessage="The app encountered an unexpected error. Please refresh to continue.">
    <QueryClientProvider client={queryClient}>
      <WrapperApp />
    </QueryClientProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
